import { render, staticRenderFns } from "./ProfessionalSummery.vue?vue&type=template&id=f7afafe8&scoped=true&"
import script from "./ProfessionalSummery.vue?vue&type=script&lang=js&"
export * from "./ProfessionalSummery.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalSummery.vue?vue&type=style&index=0&id=f7afafe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7afafe8",
  null
  
)

export default component.exports